const mainTheme = {
  color: {
    face: {
      main: '#E5DFD5',
      mainLight: '#F5F3EF',
      mainDark: '#D7D1CB',
      contrast: '#FF6700',
      secondary: '#C1C6CE',
      light: '#FFFFFF',
      dark: '#000000',
    },

    text: {
      main: '#505050',
      contrast: '#FF6700',
      secondary: '#C1C6CE',
      light: '#FFFFFF',
      dark: '#000000',
    },
  },

  font: {
    family: {
      main: 'Roboto, sans-serif',
      secondary: 'Poppins, sans-serif',
      title: 'Cormorant Garamond',
    },

    size: {
      8: '8px',
      10: '10px',
      12: '12px',
      14: '14px',
      base: '16px',
      18: '18px',
      20: '20px',
      21: '21px',
      24: '24px',
      25: '25px',
      28: '28px',
      30: '30px',
      32: '32px',
      45: '45px',
      60: '60px',
      70: '70px',
    },

    weight: {
      xs: 200,
      s: 300,
      m: 400,
      l: 700,
      xl: 800,
    },

    spacing: {
      xs: '2px',
      s: '3px',
      m: '4px',
      l: '5px',
      xl: '6px',
    },
  },
}

export default mainTheme
